/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-budget-sub-items';

export const EntityBudgetSubItemApi = {
  findOne: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithEntity: async (option: any) => {
    let url = `${pathname}/find-for-select`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  filter: async (option: FilterEntityBudgetSubItemOption) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: CreateEntityBudgetSubItemBody) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (params: {
    id: string;
    body: UpdateEntityBudgetSubItemBody;
  }) => {
    const { id, body } = params;

    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FilterEntityBudgetSubItemOption {
  page?: number;
  take?: number;
  skip?: number;
  reserved?: boolean;
  type?: number;
  name?: number;
  order?: any;
  entityID?: string;
  entityBudgetItemID?: string;
}

export interface CreateEntityBudgetSubItemBody {
  entityBudgetItemID: string;
  name?: string;
  description?: string;
}

export interface UpdateEntityBudgetSubItemBody {
  entityBudgetItemID: string;
  name?: string;
  description?: string;
  status?: number;
}
